import { render, staticRenderFns } from "./AmexCredsHelpPopup.vue?vue&type=template&id=2a5bdfd4&scoped=true&"
import script from "./AmexCredsHelpPopup.vue?vue&type=script&lang=js&"
export * from "./AmexCredsHelpPopup.vue?vue&type=script&lang=js&"
import style0 from "./AmexCredsHelpPopup.vue?vue&type=style&index=0&id=2a5bdfd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5bdfd4",
  null
  
)

export default component.exports